"use client";

import { useEffect } from "react";

import type { Locale } from "@/lib/locales";

interface LangSyncProps {
  locale: Locale;
}

export default function LangSync({ locale }: LangSyncProps) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
